import React, { useState, useEffect } from "react";

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import "./FoldingFrame.css"

export default function FoldingFrame(props) {
  const { children, open } = props;

  const [openChild, setOpenChild] = useState(open);

  useEffect(() => {
    setOpenChild(open);
  }, [open])

  function handleClickOpen() {
    setOpenChild(!openChild);
  }

  return <div className="foldingContainer">
    <div className="folding" onClick={handleClickOpen}>
      {
        openChild ?
          <ChevronLeftIcon htmlColor="#fff" fontSize="small" /> :
          <ChevronRightIcon htmlColor="#fff" fontSize="small" />
      }
    </div>
    <div className={`foldingTarget ${openChild ? 'targetOpen' : 'targetClose'}`}>
      {children}
    </div>
  </div>
}